export default __webpack_public_path__ + "static/media/pic10.611a64f6.jpg";